import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import PrintButton from 'components/shared/PrintButton';

import { toFriendlyDateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

import { PaymentStatus } from 'components/shared/StatusHelper';
import RentBreakdown from 'components/shared/RentBreakdown';
import HistoricPayments from './shared/HistoricPayments';

import LandlordLogo from 'components/shared/LandlordLogo';

let TenantReceiptDialog = class TenantReceiptDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  render() {
    const data = this.props.paymentDetails || { historic_payments: [] };
    const paymentDetails = data.payment_details || [];
    const logoHeight = this.props.landlordHasUploadedLogo ? '70px' : '50px';
    const logoBottomMargin = this.props.landlordHasUploadedLogo ? '0px' : '10px';

    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={() => this.props.toggleDialog(null)}
          aria-labelledby="payment-details-dialog"
          classes={{ paper: 'form-dialog' }}
          fullScreen={this.props.fullScreen}
        >
          <DialogTitle id="payment-details-dialog">
            <div className="row" style={{ padding: '10px 0 15px', marginBottom: logoBottomMargin }}>
              <LandlordLogo height={logoHeight} maxWidth="273px" />
            </div>
            <h3 style={{ textAlign: 'center', margin: '10px 0 0' }}>
              {this.props.translate('paymentReceipt')}&nbsp;
              <span>{<PaymentStatus style={{ fontSize: '52%' }} status={data.status} />}</span>
            </h3>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div
                className="row"
                style={{ fontSize: '15px', margin: '15px auto 0', maxWidth: '350px' }}
              >
                <RentBreakdown paymentDetails={paymentDetails} />
              </div>

              <div className="row" style={{ margin: '0px -20px' }}>
                <hr style={{ margin: '10px 0' }} />
              </div>

              <div
                className="row"
                style={{ fontSize: '15px', margin: '0px auto 10px', maxWidth: '350px' }}
              >
                <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                  <div className="col-xs-6" style={{ padding: '0px 5px', fontWeight: '800' }}>
                    <h4 style={{ margin: 0 }}> {this.props.translate('total')} </h4>
                  </div>
                  <div className="col-xs-6" style={{ padding: '0px 5px', textAlign: 'right' }}>
                    <p id="no-margin"> {data.amount} </p>
                  </div>
                </div>
                <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                  <div className="col-xs-6" style={{ padding: '0px 5px', fontWeight: '800' }}>
                    <h4 style={{ margin: 0 }}> {this.props.translate('totalOutstanding')}</h4>
                  </div>
                  <div className="col-xs-6" style={{ padding: '0px 5px', textAlign: 'right' }}>
                    <p id="no-margin"> {data.amount_outstanding} </p>
                  </div>
                </div>
              </div>

              <h5 style={{ textAlign: 'center', margin: '18px 0 25px' }}>
                {this.props.translate('thisPayment')}{' '}
                {data.due_date > new Date()
                  ? this.props.translate('isDueOn')
                  : this.props.translate('wasDueOn')}{' '}
                <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>
                  {toFriendlyDateString(data.due_date, { language: this.props.currentLanguage })}
                </b>
                &nbsp;{this.props.translate('forUnit')} {data.unit} {this.props.translate('at')}{' '}
                {data.property}
              </h5>
            </div>

            <HistoricPayments data={data} />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={() => this.props.toggleDialog(null)}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              {this.props.translate('close')}
            </FlatButton>
            <PrintButton
              hideElementsByIds={[
                'appbar',
                'transactions-drawer',
                'show-previous-rents',
                'payments-table',
              ]}
              style={{ color: '#fff', backgroundColor: AccentColor(), float: 'right' }}
            />
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

TenantReceiptDialog = connect(state => ({
  currentLanguage: state.locale.currentLanguage,
}))(TenantReceiptDialog);

export default withMobileDialog()(localize()(TenantReceiptDialog));
